const mutations = {
    COMMIT_LOADING_TRANSACTION_STATUS: (state, payload) => {
        state.loading_transaction_status = payload
    },

    COMMIT_TRANSACTION_DETAILS: (state, payload) => {
        state.transaction_details = payload
    },
}

export default mutations
